"use client";
import { useEffect } from "react";
import type Lenis from "lenis";

let instance: Lenis | null = null;

/** The active Lenis instance, or null where smooth scrolling is off (touch devices, reduced motion). */
export function getLenis(): Lenis | null {
  return instance;
}

/**
 * Smooth wheel scrolling on mouse/trackpad devices only. Lenis runs a
 * requestAnimationFrame loop for the page's whole lifetime and does nothing for
 * native touch scrolling, so phones skip it entirely — and it's loaded with a
 * dynamic import, keeping it out of the initial bundle (SEO spec 3.4).
 * Children render untouched either way.
 */
function SmoothScroll({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine || reduced) return;

    let cancelled = false;
    import("lenis").then(({ default: LenisCtor }) => {
      if (cancelled) return;
      instance = new LenisCtor({ autoRaf: true });
    });
    return () => {
      cancelled = true;
      instance?.destroy();
      instance = null;
    };
  }, []);

  return <>{children}</>;
}

export default SmoothScroll;
